import styled from "styled-components";

const Styles = styled.div`
  &.section-tit-area {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    & .extra-area {
      display: inline-flex;
      align-items: center;
      margin-bottom: 8px;
      flex-wrap: wrap;
      & .ant-space {
        flex-wrap: wrap;
      }
    }

    & .page-tit-2 {
      font-size: 16px;
      height: 32px;
      line-height: 32px;
    }

    & .page-tit-p {
      font-size: 16px;
      font-weight: 800;
      height: 32px;
      line-height: 32px;
    }
  }
`;

export default Styles;
